// IMPORTANT: do not add anything here without strong need
// Always use ui-components useDateTime instead: import { useDateTime } from '@ai/ui-components'
export const currentTZDateAndTimeToTimestamp = (
  date?: string | null,
  time?: string | null,
): number | undefined => {
  if (!date) return undefined

  const [year, month, day] = date.split('-').map(Number)
  const [hour = 0, minute = 0] = (time ?? '00:00').split(':').map(Number)

  return new Date(year, month - 1, day, hour, minute, 0, 0).getTime()
}

export const timestampToUtcIsoString = (timestamp: number): string =>
  new Date(timestamp).toISOString()
